import { z } from "zod";
/**
 * Request payload schemas shared by the API (for runtime validation) and the web app
 * (for form validation), so the two can never drift apart.
 */
export const emailSchema = z
    .string()
    .trim()
    .min(3)
    .max(254)
    .email("请输入有效的邮箱地址");
export const passwordSchema = z
    .string()
    .min(8, "密码至少需要 8 个字符")
    .max(200, "密码过长");
export const registerSchema = z.object({
    email: emailSchema,
    password: passwordSchema,
    displayName: z.string().trim().min(1, "请输入昵称").max(60)
});
export const loginSchema = z.object({
    email: emailSchema,
    password: z.string().min(1, "请输入密码").max(200)
});
export const ratingSchema = z.union([z.literal(1), z.literal(2), z.literal(3), z.literal(4)]);
export const studyModeSchema = z.enum(["FLASHCARD", "QUIZ", "EXAM"]);
export const studyFilterSchema = z.enum(["MIXED", "DUE_ONLY", "NEW_ONLY", "STARRED", "DIFFICULT", "MISTAKES"]);
export const questionScopeSchema = z.enum(["FEDERAL", "STATE"]);
export const topicSlugSchema = z.string().regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/);
export const studyQueueQuerySchema = z.object({
    filter: studyFilterSchema.default("MIXED"),
    limit: z.coerce.number().int().min(1).max(100).default(20),
    scope: questionScopeSchema.optional(),
    /** Restrict the queue to one knowledge topic. */
    topic: topicSlugSchema.optional(),
    /** Minutes to add to UTC to reach the learner's local day, so daily limits reset at their midnight. */
    tzOffsetMinutes: z.coerce.number().int().min(-840).max(840).default(0)
});
export const submitReviewSchema = z.object({
    questionId: z.number().int().positive(),
    rating: ratingSchema,
    mode: studyModeSchema.default("FLASHCARD"),
    /** How long the learner looked at the card, in milliseconds. Capped server-side. */
    durationMs: z.number().int().min(0).max(3_600_000).default(0),
    /** Present for QUIZ mode; lets the server record which distractor was picked. */
    selectedOptionId: z.number().int().positive().nullable().default(null)
});
export const questionListQuerySchema = z.object({
    search: z.string().trim().max(200).optional(),
    scope: questionScopeSchema.optional(),
    state: z.enum(["NEW", "LEARNING", "REVIEW", "RELEARNING"]).optional(),
    starred: z
        .union([z.literal("true"), z.literal("false")])
        .transform((value) => value === "true")
        .optional(),
    onlyImages: z
        .union([z.literal("true"), z.literal("false")])
        .transform((value) => value === "true")
        .optional(),
    page: z.coerce.number().int().min(1).default(1),
    pageSize: z.coerce.number().int().min(1).max(100).default(25)
});
export const answerExamSchema = z.object({
    position: z.number().int().min(1).max(60),
    /** null clears a previously given answer. */
    optionId: z.number().int().positive().nullable()
});
export const updateSettingsSchema = z.object({
    desiredRetention: z.number().min(0.7).max(0.98).optional(),
    maximumIntervalDays: z.number().int().min(1).max(36500).optional(),
    dailyNewLimit: z.number().int().min(0).max(310).optional(),
    dailyReviewLimit: z.number().int().min(0).max(2000).optional(),
    bundesland: z.string().trim().min(2).max(2).optional(),
    showChinese: z.boolean().optional(),
    showEnglish: z.boolean().optional(),
    shuffleOptions: z.boolean().optional(),
    showQuestionTranslation: z.boolean().optional()
});
export const statsQuerySchema = z.object({
    /** Minutes to add to UTC to reach the learner's local day boundary, e.g. 120 for CEST. */
    tzOffsetMinutes: z.coerce.number().int().min(-840).max(840).default(0),
    /** How many days of history the activity heatmap should cover. */
    days: z.coerce.number().int().min(7).max(400).default(180)
});
export const starSchema = z.object({
    starred: z.boolean()
});
//# sourceMappingURL=schemas.js.map